enum TimingFinishEventType {
	DURATION = 0,
	IDLE_TIMEOUT = 1,
	SCREEN_TAP = 2,
}
export default TimingFinishEventType;
